<template>
  <div class="forgotPass">
    <Header />
    <div class="forgotPass__menu">
      <div class="container">
        <div class="container__content">
          <span class="container__title">Reset hasła</span>

          <span class="container__subtitle">W celu dokonania zmiany, wpisz nowe hasło.</span>
          <div class="forgotPass__content">
          <LoginModalInput type="password" placeholder="Nowe hasło" v-model="newPassword" />
          <LoginModalInput
            type="password"
            placeholder="Powtórz nowe hasło"
            v-model="repeatPassword"
          />
                  </div>
                   <span class="login__invalid" v-if="invalid">Podane hasła nie zgadzają się.</span>

        <div class="forgotPass__buttons">
          <SelectButton buttonName="Zatwierdż" :action="this.reset" />
        </div>

        </div>


      </div>
    </div>
    <Rodo/>
  </div>
</template>

<script>
import Header from "@/components/Header/Desktop/Header.vue";
import LoginModalInput from "@/ui/LoginModalInput.vue";
import SelectButton from '@/ui/SelectButton.vue';
import Rodo from '@/components/Rodo/Mobile/Rodo.vue';
import mixin from '../mixin.js';

export default {
  mixins: [mixin],
  components: {
    Header,
    LoginModalInput,
    SelectButton,
    Rodo
  }
};
</script>

<style scoped lang="scss">
.forgotPass {
    &__buttons {
        width: 15%;
            margin-left: 6%;
                width: 25%;
    margin-left: 37.5%;


    }
    &__content {

    display: flex;
   margin-top: 2rem;
    flex-direction: column;
    width: 80%;
    margin-left: 10%;
    font-family: "Poppins", sans-serif;
    justify-content: space-between;
    height: 8rem;

    }
  &__menu {
    margin-top: -17rem;
  }
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex: 1;
    margin-top: 1.25rem;

    &__subtitle {
      font-family: "Poppins", sans-serif;
      font-size: 0.875rem;
      line-height: 1.375rem;
      display: block;
      margin-top: 2.25rem;
      text-align: center;
    }

    &__content {
      width: 94%;
      height: 100%;
      background-color: #fefefe;
      border-radius: 5px;
min-height: 50rem;
margin: auto;
    }

    &__title {
      font-size: 1.3rem;
      font-family: "Poppins", sans-serif;
      text-transform: uppercase;
      font-weight: 700;
      position: relative;
      margin-top: 4rem;
      margin-left: 3rem;
      display: inline-block;
      &:after {
        content: "";
        position: absolute;
        width: 1.1rem;
        height: 1.1rem;
        background-color: #df2860;
        left: -1.5rem;
        top: 0%;
      }
    }
  }


}
</style>
